import { useAtomValue } from 'jotai';
import { userAtom } from '../../../store/atom';
import AnnualReviewComponent from '../../../components/annual-review/AnnualReview';
import { useEffect, useState } from 'react';
import { getAnnualCycleById } from '../../../services/annualServices';
import { annualReviewStatuses } from '../../../helper';

const AnnualReview = () => {
  const { selectedMentee, cycleId } = useAtomValue(userAtom);
  const [cycleStatus, setCycleStatus] = useState<string | null>(null);

  useEffect(() => {
    const fetchCycleStatus = async () => {
      if (cycleId) {
        const { data } = await getAnnualCycleById(cycleId, 'hr');
        if (data) {
          setCycleStatus(annualReviewStatuses[data.status]);
        }
      }
    };
    fetchCycleStatus();
  }, [cycleId]);

  if (!selectedMentee) return <>No mentee selected</>;
  if (!cycleId) return <>No cycle selected</>;
  return (
    <AnnualReviewComponent
      selectedMentee={selectedMentee}
      cycleId={cycleId}
      type="hr"
      cycleStatus={cycleStatus}
    />
  );
};

export default AnnualReview;
